import styled from "styled-components";

const HeadingCell = styled.th`
  text-transform: capitalize;
  text-align: left;
`;

export default HeadingCell;
